import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FieldArrayType, FormlyModule } from '@ngx-formly/core';

import { MatCard } from '@angular/material/card';
import { MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'formly-array-type',
    templateUrl: './array.type.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormlyModule, MatCard, MatIconButton, MatTooltip, MatIcon]
})
export class ArrayTypeComponent extends FieldArrayType { }